import {defineType} from 'sanity'

const COMMON_NAMES = [
  'parentNode',
  'childNodes',
  'firstChild',
  'lastChild',
  'nextSibling',
  'previousSibling',
  'parentElement',
  'textContent',
  'nodeType',
  'nodeName',
  'nodeValue',
  'ownerDocument',
  'baseURI',
  'isConnected',
  'children',
  'firstElementChild',
  'lastElementChild',
  'nextElementSibling',
  'previousElementSibling',
  'childElementCount',
  'innerHTML',
  'outerHTML',
  'className',
  'classList',
  'tagName',
  'attributes',
  'scrollTop',
  'scrollLeft',
  'scrollWidth',
  'scrollHeight',
  'clientTop',
  'clientLeft',
  'clientWidth',
  'clientHeight',
  'offsetParent',
  'offsetTop',
  'offsetLeft',
  'offsetWidth',
  'offsetHeight',
]

export const domAttrsAsFieldNames = defineType({
  name: 'domAttrsAsFieldNames',
  type: 'document',
  title: 'Document with various common DOM attributes as field names',
  fields: COMMON_NAMES.map((name) => ({name, type: 'string', title: name})),
})
